import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mobileimg/mobilelog.png'
import _imports_1 from '@/assets/mobileimg/mobileopen.png'


const _withScopeId = n => (_pushScopeId("data-v-28892524"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hidden lg:block" }
const _hoisted_2 = { class: "hello" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tab" }
const _hoisted_6 = { class: "apply" }
const _hoisted_7 = { class: "block lg:hidden fiexdbox" }
const _hoisted_8 = { class: "moible_header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "img1"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"width":"35%"}
  })
], -1))
const _hoisted_11 = { class: "mobile_apply" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.log,
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_menu, {
            "default-active": _ctx.activeIndex,
            class: "el-menu-demo",
            mode: "horizontal",
            onSelect: _ctx.handleSelect
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "1" }, {
                default: _withCtx(() => [
                  _createTextVNode("首页")
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "2" }, {
                title: _withCtx(() => [
                  _createTextVNode("解决方案")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "2-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode("EPM平台")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "2-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("绩效管理")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "2-3" }, {
                    default: _withCtx(() => [
                      _createTextVNode("CRM系统")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "2-4" }, {
                    default: _withCtx(() => [
                      _createTextVNode("项目管理")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "2-5" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全面预算")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "2-6-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode("审计作业平台")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "2-6-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("函证管理系统")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "3" }, {
                default: _withCtx(() => [
                  _createTextVNode("服务与支持")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "4" }, {
                default: _withCtx(() => [
                  _createTextVNode("合作伙伴")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "5" }, {
                default: _withCtx(() => [
                  _createTextVNode("关于银杰")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active", "onSelect"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "large",
            onClick: _ctx.apply
          }, {
            default: _withCtx(() => [
              _createTextVNode("演示申请")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("img", {
          src: _imports_1,
          alt: "",
          class: "img2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openright && _ctx.openright(...args)))
        })
      ]),
      _createVNode(_component_el_drawer, {
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.drawer) = $event)),
        direction: _ctx.direction,
        size: "80%"
      }, {
        title: _withCtx(() => [
          _hoisted_10
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "tac" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu, {
                    "default-active": "2",
                    class: "el-menu-vertical-demo",
                    onSelect: _ctx.handleSelect
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("首页")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_sub_menu, { index: "2" }, {
                        title: _withCtx(() => [
                          _createTextVNode("解决方案")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, { index: "2-1" }, {
                            default: _withCtx(() => [
                              _createTextVNode("EPM平台")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "2-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode("绩效管理")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "2-3" }, {
                            default: _withCtx(() => [
                              _createTextVNode("CRM系统")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "2-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode("项目管理")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "2-5" }, {
                            default: _withCtx(() => [
                              _createTextVNode("全面预算")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_sub_menu, { index: "2-6" }, {
                            title: _withCtx(() => [
                              _createTextVNode("专业审计")
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_menu_item, { index: "2-6-1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("审计作业平台")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_menu_item, { index: "2-6-2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("函证管理系统")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "3" }, {
                        default: _withCtx(() => [
                          _createTextVNode("服务与支持")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "4" }, {
                        default: _withCtx(() => [
                          _createTextVNode("合作伙伴")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "5" }, {
                        default: _withCtx(() => [
                          _createTextVNode("关于银杰")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSelect"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "large",
              onClick: _ctx.apply
            }, {
              default: _withCtx(() => [
                _createTextVNode("演示申请")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "direction"])
    ])
  ], 64))
}